module.exports = __webpack_public_path__ + "static/media/about.dde34190.jpg";